
import { Component, Getter, Action, Prop, mixins } from "nuxt-property-decorator"
import Blocks from "~/mixins/blocks"
import {
  SET_PICKUP_PROPERTY_TYPE,
  SET_DELIVERY_PROPERTY_TYPE,
  SET_LISTING
} from "~/store/listing/actions"
import { GET_PICKUP_PROPERTY_TYPE, GET_DELIVERY_PROPERTY_TYPE } from "~/store/listing/getters"
import InitialListing from "~/store/listing/state"
import PropertyTypeSelect from "~/components/parts/PropertyTypeSelect.vue"
import { PROPERTY_TYPE_LIST } from "~/constants/listing"

@Component({
  components: { PropertyTypeSelect }
})
export default class OldPropertyInput extends mixins(Blocks) {
  getPropertyTypes: any[] = PROPERTY_TYPE_LIST

  @Prop({ required: true, type: Object }) block: Record<string, any>
  @Prop({ default: false, type: Boolean }) virgin: boolean
  @Prop({ default: true, type: Boolean }) lazy: boolean

  @Getter(GET_PICKUP_PROPERTY_TYPE, { namespace: "listing" }) getPickupPropertyType: string | null
  @Getter(GET_DELIVERY_PROPERTY_TYPE, { namespace: "listing" }) getDeliveryPropertyType:
    | string
    | null

  @Action(SET_PICKUP_PROPERTY_TYPE, { namespace: "listing" }) setPickupPropertyType: Function
  @Action(SET_DELIVERY_PROPERTY_TYPE, { namespace: "listing" }) setDeliveryPropertyType: Function
  @Action(SET_LISTING, { namespace: "listing" }) setListing: Function

  created() {
    this.setListing(InitialListing())
  }

  get attributes() {
    return this.virgin ? null : this.Blocks_getAttributes(this.block)
  }

  get pickupPropertyType(): string | null {
    return this.getPickupPropertyType
  }

  set pickupPropertyType(value) {
    this.setPickupPropertyType(value)
  }

  get deliveryPropertyType(): string | null {
    return this.getDeliveryPropertyType
  }

  set deliveryPropertyType(value) {
    this.setDeliveryPropertyType(value)
  }
}
